import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import StaticCreateAccountForm from 'StaticRequestSignatureContentSection/components/StaticCreateAccountForm';
import StaticCreateAccountErrorBox from 'StaticRequestSignatureContentSection/components/StaticCreateAccountErrorBox';

export class StaticCreateAccountSection extends React.Component {
  constructor(props) {
    super(props);
    this.setErrorBoxState = this.setErrorBoxState.bind(this);
    this.onBackClickOverride = this.onBackClickOverride.bind(this);

    this.state = {
      showErrorBox: false,
      errorMessage: '',
    };

    // Update component copy if Create Account Section is on last step of builder
    if (window.createAccountScreen === this.props.sectionKeys.length - 1) {
      this.sectionHeader = 'Almost Done! Create an Account to Save Your Document';
      this.saveButtonCta = 'Save & Create Account';
      this.backButtonCta = 'Back';
      this.onBackClickOverride = null;
      this.postSubmitAction = 'redirect';
    } else {
      this.sectionHeader = this.props.sectionHeader;
      this.saveButtonCta = this.props.saveButtonCta;
      this.backButtonCta = this.props.backButtonCta;
      this.postSubmitAction = 'nextBuilderStep';
    }
  }

  onBackClickOverride(event) {
    event.preventDefault();
    if (this.props.trackingId) {
      window.localStorage.setItem('createAccountLaterStaticBuilderTrackingId', this.props.trackingId);
    }
    window.moveCreateAccountSection();
  }

  setErrorBoxState(state, message) {
    this.setState({
      showErrorBox: state,
      errorMessage: message,
    });
  }

  render() {
    return (
      <div id="screen" className="static-request-signature-content-section page">
        <h2>{this.sectionHeader}</h2>
        {this.state.showErrorBox &&
          <StaticCreateAccountErrorBox errorMessage={this.state.errorMessage} />
        }
        <p className="lighter-text">
          {this.props.sectionSubHeader}
        </p>
        <div className="innerContent">
          <StaticCreateAccountForm
            setErrorBoxState={this.setErrorBoxState}
            saveButtonCta={this.saveButtonCta}
            backButtonCta={this.backButtonCta}
            onBackClickOverride={this.onBackClickOverride}
            trackDropdownSelection={false}
            postSubmitAction={this.postSubmitAction}
            trackingId={this.props.trackingId}
          />
        </div>
      </div>
    );
  }
}

StaticCreateAccountSection.propTypes = {
  sectionHeader: PropTypes.string,
  sectionSubHeader: PropTypes.string,
  backButtonCta: PropTypes.string,
  saveButtonCta: PropTypes.string,
  trackingId: PropTypes.string,
  sectionKeys: PropTypes.arrayOf(PropTypes.string),
};

StaticCreateAccountSection.defaultProps = {
  saveButtonCta: 'Create Account',
  backButtonCta: 'I\'ll Do This Later',
  trackingId: 'Section 4',
  sectionHeader: 'Don\'t Lose Your Hard Work! Create an Account to Save Your Document',
  sectionSubHeader: 'Create a free account to save your progress on this form. You can come back to it at any time.',
  sectionKeys: [],
};

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  sectionKeys: StaticBuilderReducer.sectionKeys,
});

export default ReactRedux.connect(
  mapStateToProps,
)(StaticCreateAccountSection);



// WEBPACK FOOTER //
// ./src-react/StaticCreateAccountSection/index.jsx